import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer, CartesianGrid
} from 'recharts';
import { Paper, Typography, Skeleton } from '@mui/material';

const MonthlyProductionChart = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" gutterBottom>
        🏭 Producción mensual (últimos 12 meses)
      </Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data} margin={{ top: 20, left: 0, right: 20, bottom: -10 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <RechartsTooltip formatter={(value) => `${value} unidades`} />
            <Line type="monotone" dataKey="units" stroke="#1976d2" strokeWidth={2} />
            </LineChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default MonthlyProductionChart;
